import { resolveComponent as c, openBlock as t, createElementBlock as r, Fragment as i, renderList as m, normalizeClass as a, createVNode as p, createElementVNode as g, toDisplayString as u } from "vue";
/* empty css                  */
import _ from "../../_virtual/_plugin-vue_export-helper.js";
import f from "../../atoms/icon/icon.vue.js";
const y = {
  name: "DsLegendGroup",
  components: { DsIcon: f },
  props: {
    items: {
      type: Array,
      required: !0,
      validator: (s) => s.every((o) => ["color", "text"].every((e) => e in o))
    }
  }
}, x = {
  "aria-hidden": "true",
  class: "ds-label-group ds-display-flex ds-flex-wrap",
  "data-j-legend-group": ""
}, h = { class: "ds-text-small ds-color-grey-1900 ds-margin-left-12" };
function v(s, o, e, D, b, $) {
  const d = c("DsIcon");
  return t(), r("div", x, [
    (t(!0), r(i, null, m(e.items, (l, n) => (t(), r("div", {
      key: `ds-label-group-item-${n}`,
      class: a(["ds-label-group__label ds-display-flex ds-align-items-center", { "ds-md-margin-right-24": n !== e.items.length - 1 }]),
      "data-j-legend-group-item": ""
    }, [
      p(d, {
        category: "shapes",
        name: "dot",
        class: a(`ds-color-${l.color}`)
      }, null, 8, ["class"]),
      g("p", h, u(l.text), 1)
    ], 2))), 128))
  ]);
}
const B = /* @__PURE__ */ _(y, [["render", v]]);
export {
  B as default
};
